import toasteventbus from "primevue/toasteventbus"
import { useAuthenticationStore } from "@/store"
import i18n from "@/languages/i18n"

const { t } = i18n.global

const handle401 = () => {
  if (useAuthenticationStore().isLoggedIn) {
    toasteventbus.emit("add", {
      severity: "error",
      summary: t("common.toasts.expiredSession"),
      detail: t("common.toasts.expiredSessionDetail"),
      life: 5000
    })

    useAuthenticationStore().unauthorize()
  }
}

const handleDefault = (message) => {
  toasteventbus.emit("add", {
    severity: "error",
    summary: t("common.toasts.somethingWentWrong"),
    detail: message || t("common.toasts.defaultError"),
    life: 5000
  })
}

export const errorHandlers = {
  401: handle401,
  default: handleDefault
}
